import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import { getModule } from './module';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';

export const ReduxInitLoadable: React.FC<{}> = () => {
  const mounted = useIsMounted();
  return mounted ? <DynamicModuleLoader modules={[getModule()]} /> : null;
};
ReduxInitLoadable.displayName = 'TierConsumerReduxLoadable';

export default ReduxInitLoadable;
